const content = `
<p class="ql-align-center">
  <strong style="color: rgb(31, 35, 41);">
    <u>
      迭代⽣效时间：2020年6⽉15⽇
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    特别提示：
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    【审慎阅读】
  </span>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      图灵深视（北京）科技有限公司
    </u>
  </strong>
  <span style="color: rgb(31, 35, 41);">
    （以下统称“ 图灵鉴定App/微信⼩程序/图灵鉴定H5” 或“ 平台” ） 在此特别提醒：
  </span>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      在您注册成为⽤户（包括买家和卖家，以及使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5服务的其他⽤户，以下简称“⽤户”或“您”）之前，请认真阅读本《⽤户协议》（以下简称“本协议”），特别是免除或者限制责任的条款、法律适⽤和争议解决条款等以粗体划线重点标识的条款。
    </u>
  </strong>
  <span style="color: rgb(31, 35, 41);">
    如果您对本协议的内容有任何疑问，请向图灵鉴定App/微信⼩程序/图灵鉴定H5客服咨询。
  </span>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      【签约动作】
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      当您按照注册或登录⻚⾯提示填写信息、阅读并同意本协议且完成全部注册或登录程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与平台就本协议达成⼀致，成为图灵鉴定App/微信⼩程序/图灵鉴定H5⽤
      户。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应⽴即停⽌注册或登录。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<h2>
  <span style="color: rgb(31, 35, 41);">
    【争议解决】
  </span>
</h2>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    本协议的效⼒、解释及纠纷的解决，适⽤于中华⼈⺠共和国法律。
  </span>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      若⽤户和图灵鉴定App/微信⼩程序/图灵鉴定H5 之间发⽣任何纠纷或争议，⾸先应友好协商解决。协商不成的，任何⼀⽅均可向北京市海淀区⼈⺠法院提起诉讼。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    【版本更新】
  </span>
</p>
<p>
  <u style="color: rgb(31, 35, 41);">
    根据国家法律法规变化或平台运营需要，本协议可由图灵鉴定App/微信⼩程序/图灵鉴定H5不时地更新或修改，
  </u>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      修改后的协议条款经提前7⽇公示即⽣效并代替原来的协议条款
    </u>
  </strong>
  <u style="color: rgb(31, 35, 41);">
    ， 相关内容将公布在本软件等客户端上或以其他⽅式通知你，您可随时查阅最新版协议条款。
  </u>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      在图灵鉴定App/微信⼩程序/图灵鉴定H5修改协议条款后，如果您不接受修改后的条款，请⽴即停⽌使⽤图灵鉴定App/微信⼩程序 /图灵鉴定H5提供的服务，您继续使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5提供的服务将被视为接受修改后的协议
      。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼀、服务说明
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5为图灵深视（北
    </u>
    京）科技有限公司开发、运营、管理的⼀款为消费者提供闲置物品⽹络经营交易场所的软件产品，平台仅就⽤
    <u>
      户在图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5展示物品、服务
    </u>
    信息、寻找交易对象并完成商品交易提供技术服务，同
    <u>
      时为⽤户提供商品鉴别服务。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、平台提供如下两种服务内容：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）为买卖双⽅交易商品提供⽹络经营场所，即图灵鉴定A
    </u>
    pp
    <u>
      /微信⼩程序/图灵鉴定H5利⽤⾃身技术能⼒搭建电
    </u>
    商平台供买卖双⽅进⾏⾃由交易，并按照卖家出价⻚⾯
    <u>
      载明的⽐例向卖家收取平台技术服务费。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）鉴别查验服务，即图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5为⽤户提供商品查验、包装服务、鉴别服务。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    3、除⾮本协议另有其他明示规定，平台有权随时强化现有功能或增加任何新功能，包括在图灵鉴定App/微信⼩程序/图灵鉴定H5上推出任何新的服务内容。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼆、账号注册、使⽤及安全
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、您确认，在您完成注册程序并实际使⽤服务时，您应 当具备中华⼈⺠共和国法律规定的与您⾏为相适应的⺠ 事⾏为能⼒， 如您不具有前述⺠事⾏为能⼒的，则您应确保您在平台上的任何⾏为均应事先获得监护⼈的同
      意，并由您与您的监护⼈共同承担不利后果。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、图灵鉴定App/微信⼩程序/图灵鉴定H5仅允许每位⾃然⼈申请⼀个账号， 如有证据证明或按照后台显示的申请信息证明您不当申请多个账号的，平台有权采取冻结、关闭账号、取消订单或拒绝提供服务等措施。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、您应确保在注册及使⽤平台服务时所填写的信息均真实合法。如您在平台售卖商品应完成实名认证。 若您提供任何违法、⽆效的信息，或提供违法、侵权、不道德或平台认为不适合在平台上展示的资料，或者平台有理由怀疑您的资料属于程序或恶意操作，平台有权冻结、关闭您的帐号、取消您的订单、拒绝您于现在和未来使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5服务的全部或任何部分，或采取其他合理措施。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 平台只允许每位⾃然⼈使⽤⼀个图灵鉴定App/微信⼩程序/图灵鉴定H5账户，⽤户完成申请注册⼿续后，获得图灵鉴定App/微信⼩程序/图灵鉴定H5账户的使⽤权，该使⽤权仅属于初始申请注册⼈，禁⽌赠与、借⽤、租⽤、转让或售卖。⽤户不得恶意注册、不当注册或不当使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5的账户。若⽤户有前述情形，图灵鉴定App/微信⼩程序/图灵鉴定H5有权直接采取⼀切必要措施，取消⽤户在图灵鉴定App/微信⼩程序/
      图灵鉴定H5的⼀切权利、权益，包括但不限于删除发布内容、暂停、查封、冻结账户、取消交易、停⽌提供服务，注销⽤户相关信息、收回⽤户的图灵鉴定App/微信⼩程序
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5 、您的账户由您⾃⾏设置⽤户名及密码并保管，您应务必保管好您的账户及密码。 如果由于您未妥善保管⾃⼰的账号和密码⽽对您或第三⽅造成任何损失或损害，平台⽆法也不承担任何法律责任。您应通过司法、⾏政等救济途径向侵权⾏为⼈追偿，并⾃⾏向第三⽅承担法律责任，平台将在⾏政或司法机关的要求下提供必要的配合及协助。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      6、 您应对您账户下的所有⾏为及结果负责，包括但不限于发布信息、购买商品或服务、发布社区动态内容、在线签署各类协议等。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      7、您的图灵鉴定App/微信⼩程序/图灵鉴定H5账号遭受未获授权的使⽤、或者发⽣其他账号安全问题时，建议您⽴即通知平台。 除图灵鉴定App/微信⼩程序/图灵鉴定H5存在法定过错外，平台不对受理过程中产⽣的损失扩⼤承担任何法律责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      8、 您不得开发或委托第三⽅开发/使⽤应⽤程序侵⼊平台进⾏批量数据抓取、下载，平台的Robots协议明令禁⽌任何数据抓取⾏为。如平台发现您实施了上述⾏为，
      则有权封禁您的账户并扣除您的全部资⾦，并就平台遭受的全部损失要求您承担赔偿责任。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    三、服务说明
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    1、图灵鉴定App/微信⼩程序/图灵鉴定H5及其合作⽅为买卖双⽅提供⽹络经营场所、商品查验及鉴别服务，
  </span>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      因此图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5并⾮商品销售主体。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、卖家依法需要取得相关⾏政许可的，应当依法取得⾏政许可，并承诺通过图灵鉴定App/微信⼩程序/图灵鉴定H5交易的商品应当符合保障⼈身、财产安全的要求和环境保护要求，不得销售法律、⾏政法规禁⽌交易的商品。如有违反前述约定的，
      图灵鉴定App/微信⼩程序/图灵鉴定H5有权采取冻结、关闭您的帐号、取消您的订单、拒绝您于现在和未来使⽤平台服务的全部或任何部分，或采取其他合理措施，并有权向有关主管部⻔反映。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、 图灵鉴定App/微信⼩程序/图灵鉴定H5向⽤户提供出售商品、购买商品的⽹络经营场所和服务，卖家上架商品时需缴纳相应的费⽤作为平台服务费（具体⻅⻚⾯详情）。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 当⽤户选择⾃主出售商品时，所提交的信息需先由平台进⾏真实性有效性审核，只有通过审核的商品才会展示在图灵鉴定App/微信⼩程序/图灵鉴定H5中进⾏销售。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、图灵鉴定App/微信⼩程序/图灵鉴定H5希望平台⽤户遵守契约精神。 因此，当卖家出售商品买家提交订单并付款超过2⼩时犹豫期后，买卖合同即告成⽴。具体交易规则请仔细阅读《买家须知》与《卖家协议》，买家提交订单的⾏为则视为买家已仔细阅读并同意接受《买家须知》，卖家确认出售的⾏为则视为买家已仔细阅读并同意接受《卖家协议》。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      6、⽤户应当清楚准确地填写送货地址、联系⼈及联系⽅式等配送信息。⽤户知悉并确认，⽤户所购买的商品应仅由⽤户填写的联系⼈接受身份查验后接收商品，因⽤户变更联系⼈或相关配送信息⽽造成的损失由⽤户⾃⾏承担。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    7、卖家在图灵鉴定App/微信⼩程序/图灵鉴定H5出售的商品多为个⼈闲置物品，
  </span>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      多数情况下出售的同⼀商品同⼀型号规格仅为⼀件，因此卖家⽆法⽀持换货，且⾮商品 真假问题⽆法⽀持7⽇⽆理由退货。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      8、 因商品价值较⾼，⽤户应使⽤顺丰快递向平台寄件，并加固商品外包装。如出现使⽤⾮指定快递、包装盒破损、运单号⽆法匹配订单号等情形的快递商品，平台有权进⾏拒收，如因此造成取消订单、⽆法退货及相应后果的，平台不承担责任；因快递原因造成的破损、
      毁损或遗失，⽤户可与快递协商解决，平台不承担责任，请谨慎选择是否⾃费保价服务。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      9、买家签收时应仔细查验商品，如发现商品（含部件） 存在破损、错发或漏发，请签收24⼩时内提供清晰的照⽚、订单号向平台客服寻求帮助，并在平台同意退货后3⽇内将商品、防伪扣连同原包装箱完好退回，防伪扣拆除视为买家认可商品。如买家未在24⼩时内联系客服或主张质量问题退回的商品符合《买家须知》所述正常质量情况的，则平台⽆法受理买家退货申请。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      10、图灵鉴定App/微信⼩程序/图灵鉴定H5⼀直致⼒于打击假冒伪劣商品。为此，平台依据平台核⼼技术AI鉴别+⼈⼯实物鉴别为买家提供商品鉴别服务。如⽤户不认同平台的鉴别结果，可在签收24⼩时内且取防伪扣前与平台客服联系，申请平台认可的第三⽅鉴别机构出具鉴别报告，如鉴别结果与平台⼀致，并给图灵鉴定造成损失的，
      您应承担相应的赔偿。如果平台出现真假判别有误的情况，平台向买家赔偿⼗倍鉴别费。因图灵鉴定App/微信⼩程序/图灵鉴定H5并⾮销售主体，因此该等责任的承担，
      并不应被视为图灵鉴定App/微信⼩程序/图灵鉴定H5存在售假⾏为所承担的赔偿责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      11、 图灵鉴定App/微信⼩程序/图灵鉴定H5抵制利⽤平台漏洞刷单、套现等获取不正当利益的⾏为，⼀经发现⽤户存在上述⾏为的，图灵鉴定App/微信⼩程序/图灵鉴定H5有权采取包括但不限于关闭交易订单、封禁⽤户账号、扣除服务费及账户余额等措施，情节严重的，平台有权移交司法机关处理。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      12、 图灵鉴定App/微信⼩程序/图灵鉴定H5为买卖双⽅提供⽹络经营场所，但并⾮货权所有⼈、亦⾮商品销售主体，因此不⽀持向⽤户开具商品销售发票，也不提供商
      品维护保养服务。在图灵鉴定App/微信⼩程序/图灵鉴定H5 销售商品的多为个⼈卖家，个⼈卖家销售闲置商品不⽀ 持开具发票。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    四、鉴别说明
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    1、图灵鉴定App/微信⼩程序/图灵鉴定H5的AI鉴别是从您上传的图⽚中提取鉴别特征，最终基于图⽚上的特征进⾏ 打分；
  </span>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 远程鉴别都不可避免地存在⼀定的局限性，不可代替实物鉴别。平台将在现有技术的基础上尽最⼤努⼒提供相应的服务，鉴别结果供您参考，平台不承担其他任何责任；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、 在图灵鉴定有操作提示的情况下由于您操作不当（包括但不限于：上传的图⽚未按示例要求拍摄、鉴别品牌选择错误、恶意拼凑图⽚）导致的鉴别结果偏差，您应
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      ⾃⾏承担后果；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 图灵鉴定对本平台的AI鉴别技术有最终解释权。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、在图灵鉴定App/微信⼩程序/图灵鉴定H5上交易的商品均由AI加⼈⼯实物鉴别，最终结果以实物为准。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <br>
</p>
<h2>
  <span style="color: rgb(31, 35, 41);">
    五、收费说明
  </span>
</h2>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 由卖家个⼈原因违约导致交易不成功的，卖家需承担对买家的违约费⽤及平台服务费、平台垫付费⽤（如 有），平台有权扣除相应费⽤。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 针对正常交易成功的订单，平台对卖家收取平台技术服务费及⽀付⼿续费。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、 卖家寄到平台的物流费⽤由卖家⾃⾏承担，平台邮寄到买家的物流费⽤由买家⾃⾏承担，如果拒收，平台有权扣除物流费⽤并终⽌订单。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    六、内容规范
  </strong>
</p>
<p>
  <span style="color: rgb(31, 35, 41);">
    1、本条所述内容是指⽤户使⽤本协议项下服务过程中所制作、上传、复制、发布、传播的任何内容，包括但不限于账号头像、 名称、 ⽤户评价等信息，或⽂字、
    语⾳、图⽚、视频、图⽂等发送、回复或⾃动回复消息和相关链接⻚⾯，以及其他使⽤账号或本协议项下的服务所产⽣的内容。
  </span>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 ⽤户确保在图灵鉴定App/微信⼩程序/图灵鉴定H5发布的内容系⽤户原创或已获得有效、完整的授权，不会侵犯任何主体的肖像权、名誉权等⼈身、财产权以及知识产权等合法权益，若因此产⽣损失和责任，由⽤户承担。同时，平台有权不经通知，直接⽴即删除或屏蔽该等内容。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、⽤户应确保通过图灵鉴定App/微信⼩程序/图灵鉴定H5 提交、制作、上传、复制、发布、传播的全部信息（包括但不限于个⼈信息、商品信息、⾔论及所作出的⾏为或事件）
      不含如下内容 ：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）反对宪法所确定的基本原则的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统⼀的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （3）损害国家荣誉和利益的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （4）煽动⺠族仇恨、⺠族歧视，破坏⺠族团结的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （5）破坏国家宗教政策，宣扬邪教和封建迷信的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （6）散布谣⾔，扰乱社会秩序，破坏社会稳定的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （7）散布淫秽、⾊情、赌博、暴⼒、凶杀、恐怖或者教唆犯罪的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （8）侮辱或者诽谤他⼈，侵害他⼈合法权益的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （9）含有法律、⾏政法规禁⽌的其他内容的信息。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 ⽤户不得利⽤图灵鉴定App/微信⼩程序/图灵鉴定H5的账户或本协议项下的服务制作、上载、复制、发布、传播如下⼲扰平台的正常运营 ，以及侵犯其他⽤户或第三⽅合法权益的内容：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）含有任何性或性暗示的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）含有辱骂、恐吓、威胁内容的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （3）含有骚扰、垃圾⼴告、恶意信息、诱骗信息的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （4）涉及他⼈隐私、个⼈信息或资料的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （5）侵害他⼈名誉权、肖像权、知识产权、商业秘密等合法权利的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （6）含有其他⼲扰本服务正常运营和侵犯其他⽤户或第三⽅合法权益内容的信息。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、 ⼀经发现，⽤户有如上情形，图灵鉴定App/微信⼩程序/图灵鉴定H5有权⽴即删除或做其他相关处理。如有必要，平台有权将对⽤户账户做冻结、封禁等处理。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    七、使⽤规则
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 ⽤户可以从App Store、各⼤应⽤商城等得到图灵鉴定App/微信⼩程序/图灵鉴定H5授权的第三⽅上获取图灵鉴定客户端软件，如果⽤户从未经图灵鉴定App/微信⼩程序/
      图灵鉴定H5授权的第三⽅获取软件或与图灵鉴定客户端软件名称相同的安装程序，图灵鉴定App/微信⼩程序/图灵鉴定H5⽆法保证该软件能够正常使⽤，并对因此给⽤户造成的损失不予负责。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 ⽤户在本协议项下的服务中或通过本协议项下的服务所传送、发布的任何内容并不反映或代表，也不得被 视为反映或代表图灵鉴定App/微信⼩程序/图灵鉴定H5的观点、⽴场或政策，平台对此不承担任何责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、⽤户不得利⽤图灵鉴定App/微信⼩程序/图灵鉴定H5的账户或本协议项下的服务进⾏如下⾏为：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）提交、发布虚假信息，或盗⽤他⼈头像或资料，冒 充、利⽤他⼈名义的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）强制、诱导其他⽤户关注、点击链接⻚⾯或分享信息的 ；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （3）虚构事实、隐瞒真相以误导、欺骗他⼈的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （4）利⽤技术⼿段批量建⽴虚假账号的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （5）利⽤图灵鉴定App/微信⼩程序/图灵鉴定H5的账户或本协议项下的服务从事任何违法犯罪活动的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （6）制作、发布与以上⾏为相关的⽅法、⼯具，或对此类⽅法、⼯具进⾏运营或传播，⽆论这些⾏为是否为商业⽬的；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （7）其他违反法律法规规定、侵犯其他⽤户合法权益、⼲扰图灵鉴定App/微信⼩程序/图灵鉴定H5正常运营或图灵鉴定App/微信⼩程序/图灵鉴定H5未明示授权的⾏为。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 ⽤户须对利⽤图灵鉴定App/微信⼩程序/图灵鉴定H5账户或本协议项下的服务传送信息的真实性、合法性、⽆害性、准确性、有效性等全权负责，与⽤户所传播的信息相关的任何法律责任由⽤户⾃⾏承担，与图灵鉴定App/微信⼩程序/图灵鉴定H5⽆关。如因此给图灵鉴定App/微信⼩程序/图灵鉴定H5或第三⽅造成损害的，⽤户应当依法予以赔偿。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、图灵鉴定App/微信⼩程序/图灵鉴定H5提供的服务中可能包括⼴告，⽤户同意在使⽤过程中显示图灵鉴定App/微信⼩程序/图灵鉴定H5和第三⽅供应商、合作伙伴提供的⼴告。除法律法规明确规定外，⽤户应⾃⾏对依该⼴告信息进⾏的交易负责，对⽤户因依该⼴告信息进⾏的交易或前述⼴告商提供的内容⽽遭受的损失或损害，平台不承担任何责任。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼋、提供者的责任
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、根据有关法律规定，图灵鉴定App/微信⼩程序/图灵鉴定H5在此郑重提醒您注意，任何经由本协议项下的服务⽽发布、上传的⽂字、资讯、资料、⾳乐、照⽚、图形、视讯、信息或其它资料（以下简称“内容”），⽆论系公开还是私下传送，均由内容提供者承担责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 图灵鉴定App/微信⼩程序/图灵鉴定H5仅为⽤户提供内容存储空间，⽆法控制经由本协议项下的服务传送之内容，因此不保证内容的正确性、完整性或品质。您已预知使⽤本协议项下的服务时，可能会接触到令⼈不快、不适当或令⼈厌恶之内容。在任何情况下，平台均不为
      任何内容负责，但平台有权依法停⽌传输任何前述内容并采取相应⾏动，包括但不限于暂停⽤户使⽤本协议项下的服务的全部或部分，保存有关记录，并向有关机关报告。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    九、数据储存
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5不对⽤户在本协议项下的服务中相关数据的删除或储存失败负责。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5在中华⼈⺠共和
    </u>
    国境内的运营业务收集或产⽣的数据均存储在中华⼈⺠
    <u>
      共和国境内服务器。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    3、商品和服务信息、交易信息保存时间⾃交易完成之⽇
    <u>
      起不少于三年。图灵鉴定A
    </u>
    p
    <u>
      p/微信⼩程序/图灵鉴定H5可以
    </u>
    根据实际情况依法⾃⾏决定⽤户在本协议项下的服务中数据的最⻓储存期限，并在服务器上为其分配数据最⼤存储空间等。⽤户可根据⾃⼰的需要⾃⾏备份本协议项
    <u>
      下的服务中的相关数据。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗、⻛险承担
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 本协议项下，图灵鉴定App/微信⼩程序/图灵鉴定H5将按“现状”和“可得到”的状态向⽤户提供平台服务，将在现有技术的基础上尽最⼤努⼒提供相应对的安全措施以保障服务安全和正常运⾏。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 ⽤户理解并同意，⽤户必须为⾃⼰注册账号下的⼀切⾏为负责，包括但不限于分享、传送、获取信息、在平台进⾏商品交易的⾏为以及由此产⽣的任何后果。⽤户应在使⽤平台过程对⾃⼰注册账号下的⼀切⾏为⾃⾏加以判断，并承担因此引起的所有⻛险和责任，包括但不限于因正确性、完整性或实⽤性的依赖⽽产⽣的⻛险。平台⽆法且不会对因⽤户⾏为⽽导致的任何损失或损害承担责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、如果图灵鉴定App/微信⼩程序/图灵鉴定H5发现或收到他⼈举报或投诉您违反本协议约定或以其他不当的⽅式使⽤本协议项下的服务或存在任何疑似或⾜以认定为恶意⾏为的，平台有权不经通知随时对相关内容进⾏删除、屏蔽，并视⾏为情节对违规帐号处以包括但不限于警告、限制或禁⽌使⽤部分或全部功能、帐号封禁、注销等措施，并公告处理结果。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 图灵鉴定App/微信⼩程序/图灵鉴定H5有权依据合理判断对违反有关法律法规或本协议规定的⾏为采取适当的法律⾏动，并依据法律法规保存有关信息向有关部⻔报告等，⽤户应独⾃承担由此⽽产⽣的⼀切法律责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、 ⽤户理解并同意，因业务发展需要，图灵鉴定App/微信⼩程序/图灵鉴定H5保留单⽅⾯对本协议项下的服务的全部或部分服务内容变更、暂停、终⽌或撤销的权利，
      但图灵鉴定App/微信⼩程序/图灵鉴定H5将按法律规定提前7⽇在平台进⾏公告。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      6、 图灵鉴定App/微信⼩程序/图灵鉴定H5仅作为闲置物品信息发布、鉴别及交易平台，就⽤户之间的物品交易活动提供平台以展示物品/服务信息、寻找交易对象、就物品/服务的交易提供鉴别服务，除平台另有约定外，平台并不作为交易双⽅之任何⼀⽅的身份参与交易⾏为，且平台不对⽤户交易履⾏能⼒负责。本协议的签署并不意味着图灵鉴定App/微信⼩程序/图灵鉴定H5为平台上交易双⽅的⾏为合法性、有效性提供任何明示或暗示的担保或承诺。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗⼀、知识产权声明
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、除⾮另有约定，您通过图灵鉴定App/微信⼩程序/图灵鉴定H5社区发布的⽤户内容的所有权、知识产权及其他法律权利，归您或您的许可⽅所有。您同意或者确保实际权利⼈同意：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）⽤户同意将在本协议项下的服务中或通过本协议项下
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      的服务所传送、发布的任何内容（包括但不限于⽂字、语⾳、图⽚、视频、图⽂），授予图灵鉴定App/微信⼩程序/图灵鉴定H5可在全球范围内、免费的、⾮独家的、可转授权的使⽤，使⽤范围包括但不限于在当前或其他⽹站、应⽤程序、产品或终端设备等，并授权图灵鉴定App/
      微信⼩程序/图灵鉴定H5对相应内容可进⾏修改、复制、改编、翻译、汇编或制作衍⽣产品。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）⽤户同意授权图灵鉴定App/微信⼩程序/图灵鉴定H5以公司名义或委托第三⽅对侵犯⽤户上传发布的享有知识产权的内容进⾏维权的权利。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、除另有特别声明外，图灵鉴定App/微信⼩程序/图灵鉴定H5提供本协议项下的服务时所依托软件的著作权、专利权及其他知识产权均归图灵鉴定App/微信⼩程序/图灵鉴定H5所有。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、图灵鉴定App/微信⼩程序/图灵鉴定H5在本协议项下的服务中所涉及的图形、⽂字或其组成，以及其他图灵鉴定App/微信⼩程序/图灵鉴定H5标志及产品、服务名称（以下统称“图灵鉴定App/微信⼩程序/图灵鉴定H5标识”）等，其著作权或商标权归图灵鉴定App/微信⼩程序/图灵鉴定H5
      所有。未经平台事先书⾯同意，⽤户不得将平台标识以任何⽅式展示或使⽤或作其他处理，也不得向他⼈表明⽤户有权展示、使⽤、或其他有权处理平台标识的⾏为。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、上述及其他任何平台或相关⼴告商依法拥有的知识产权均受到法律保护，未经平台或相关⼴告商书⾯许可，⽤户不得以任何形式进⾏使⽤或创造相关衍⽣作品。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗⼆、法律责任
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 如果平台发现或收到他⼈举报或投诉⽤户违反本协议约定的，平台有权不经通知随时对相关内容，包括但 不限于⽤户资料、⽇志、交易记录进⾏审查、删除，并
      视情节轻重对违规账号处以包括但不限于警告、账号封 禁、设备封禁、功能封禁、删除或屏蔽发布的信息、停⽌提供服务等处罚。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、因违反⽤户协议或平台规则被封禁的⽤户不会⾃动解封。可向平台提交申诉，平台将对申诉进⾏审查，并⾃⾏合理判断决定是否变更处罚措施。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、⽤户理解并同意，平台有权依合理判断对违反有关法律法规或本协议规定的⾏为进⾏处罚并公示，对违法违规的任何⽤户采取适当的法律⾏动，并依据法律法规保存有关信息向有关部⻔报告等，⽤户应承担由此⽽产⽣的⼀切法律责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 ⽤户理解并同意，因⽤户违反本协议约定，导致或产⽣的任何第三⽅主张的任何索赔、要求或损失，包括但不限于 合理的律师费 、诉讼费、执⾏费等费⽤
      ，⽤户应当赔偿平台及其合作⽅，并使之免受损害。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗三、不可抗⼒及其他免责事由
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 ⽤户理解并确认，在使⽤本协议项下的服务的过程中，可能会遇到不可抗⼒等⻛险因素，使本协议项下的 服务发⽣中断。不可抗⼒是指不能预⻅、不能克服并不
      能避免且对⼀⽅或双⽅造成重⼤影响的客观事件，包括 但不限于⾃然灾害如洪⽔、地震、瘟疫流⾏和⻛暴等以及社会事件如战争、动乱、政府⾏为等。出现上述情况时，平台将努⼒在第⼀时间与相关单位配合，及时进⾏修复，但是由此给⽤户或第三⽅造成的损失，平台及合
      作公司在法律允许的范围内免责。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、本协议项下的服务同⼤多数互联⽹服务⼀样，受包括但不限于⽤户原因、⽹络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他⼈利⽤⽤户的资料，造成现实⽣活中的骚扰；⽤户下载安装的其它软件或访问的其他⽹站中含有“
      特洛伊⽊⻢” 等病毒，威胁到⽤户的计算机信息和数据的安全，继⽽影响本协议项下的服务的正常使⽤等等。⽤户应加强信息安全及使⽤者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、 ⽤户理解并确认，本协议项下的服务存在因不可抗⼒、计算机病毒或⿊客攻击、系统不稳定、⽤户所在位置、⽤户关机以及其他任何技术、互联⽹络、通信线路原因等造成的服务中断或不能满⾜⽤户要求的⻛险，因此导致的⽤户或第三⽅任何损失，平台在法律允许的范围内免责。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 ⽤户理解并确认，在使⽤本协议项下的服务过程中存在来⾃任何他⼈的包括误导性的、欺骗性的、威胁性的、诽谤性的、令⼈反感的或⾮法的信息，或侵犯他⼈权利的匿名或冒名的信息，以及伴随该等信息的⾏为，
      因此导致的⽤户或第三⽅的任何损失，平台不承担任何 责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、 ⽤户理解并确认，平台需要定期或不定期地对图灵鉴定App/微信⼩程序/图灵鉴定H5或相关的设备进⾏检修或者维护，如因此类情况⽽造成服务在合理时间内的中断，平台⽆需为此承担任何责任，但平台应事先进⾏通告。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      6、 图灵鉴定App/微信⼩程序/图灵鉴定H5依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成图灵鉴定App/微信⼩程序/图灵鉴定H5的义务或承诺，平台不能保证及时发现违法违规或违约⾏为或进⾏相应处理。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      7、 在任何情况下，平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因⽤户使⽤平台或本协议项下的服务⽽遭受的利润损失，承担责任（即使平台已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，平台对⽤户承担的全部责任，⽆论因何原因或何种⾏为⽅式，始终不超过⽤
      户因使⽤平台提供的服务⽽⽀付给平台的费⽤(如有)。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗四、服务的变更、中断、终⽌
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、鉴于⽹络服务的特殊性，⽤户同意图灵鉴定App/微信⼩程序/图灵鉴定H5有权随时变更、中断或终⽌部分或全部的服务（包括收费服务）。图灵鉴定App/微信⼩程序/图灵鉴定H5变更、中断或终⽌的服务，图灵鉴定App/微信⼩程序/图灵鉴定H5应当在变更、中断或终⽌之前通知⽤户，并应向受影响的⽤户提供等值的替代性的服务；如⽤户不愿意接受替代性的服务，则⽤户可以选择停⽌使⽤图灵鉴定App/微信⼩程序/图灵鉴定H5提供的服务。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、 如发⽣下列任何⼀种情形，图灵鉴定App/微信⼩程序/图灵鉴定H5有权变更、中断或终⽌向⽤户提供的免费服务或收费服务，⽽⽆需对⽤户或任何第三⽅承担任何责任：
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （1）根据法律规定⽤户应提交真实信息，⽽⽤户提供的个⼈资料不真实、或与注册时信息不⼀致⼜未能提供合理 证明；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （2）⽤户违反相关法律法规或本平台规则；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （3）按照法律规定或有权机关的要求；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      （4）出于安全的原因或其他必要的情形。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    ⼗五、其他
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      1、 图灵鉴定App/微信⼩程序/图灵鉴定H5郑重提醒⽤户注意本协议中免除平台责任和限制⽤户权利的条款，请⽤户仔细阅读并理解。未成年⼈应在法定监护⼈的陪同下阅读本协议。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      2、本协议的任何条款⽆论因何种原因⽆效或不具可执⾏性，其余条款仍有效，对双⽅具有约束⼒。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      3、平台可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），⽤户在使⽤平台服务前请审慎阅读相关的单独协议；⽤户使⽤前述服务的，即视为⽤户已阅读并同意接受相关单独协议，单独协议作为本协议的组成部分，与本协议具有同等法律效⼒。如⼆者不⼀
      致，应按照单独协议内容执⾏。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      4、 本协议内容中以加粗⽅式显著标识的条款，请您着重阅读。您点击“注册”或“登录”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(31, 35, 41);">
    <u>
      5、本协议的订⽴、履⾏、效⼒、解释及争议的解决均适⽤《中华⼈⺠共和国合同法》及中华⼈⺠共和国其它法律法规。因订⽴或执⾏本协议⽽产⽣的任何争议，协议双⽅应⾸先通过协商解决。若协商不能解决，应提交本协议签订地即北京市海淀区⼈⺠法院诉讼。
    </u>
  </strong>
</p>
`
export default {
  content,
  title: '图灵鉴定用户协议'
}
